export default "__VITE_ASSET__Bil6lqtj__"